module.exports = __webpack_public_path__ + "static/media/ro.edc6ec3b.svg";